//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
const Referee = require('@/tbs/model/vo/Referee')
const Passport = require('@/libs/passport')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_RefereeInviteMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_RefereeInviteMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_RefereeInviteMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    /**
     * @api
     * Handle the creation complete condition triggered by 
     * the scene instance.
     */
    handleCreationComplete: function() {
        console.log('handleCreationComplete')
        const current = this._bridge.getRouteName()
        if (current == 'OrgInviteReferee') {
            this.fetchInvitation(this._bridge.getRouteParam('id'))
        }
        else if (current == 'OrgAcceptReferee') {
            this.target().member = this._bridge.getRouteQuery()
        }
    },
    handleCustomEvent: function(event) {
        console.log('handleCustomEvent', event)
        if (event.type == 'join') {
            this.joinOrganization()
        }
    },
    handleRouteBack: function() {
        console.log('nothing')
    },
    joinOrganization: function() {
        const self = this
        // validate the passport and prepair the one
        Passport.getPassport().then(res => {
            console.log('getPassport', res)
            if (res) {
                self.acceptInvitation(self._bridge.getRouteParam('id'))
            }
        })
    },
    acceptInvitation: function(id) {
        console.log('acceptInvitation', id)
        const self = this
        self.commitViewObjectData(self.convertor(), {id: id}, function(e) {
            console.log('commit invitation', e)
            if (e.data.payload) {
                self._bridge.goToScene('OrgAcceptReferee', {}, {
                    role: self.target().member.role,
                    organizationName: self.target().member.organizationName
                })
            }
        }, 'accept')
    },
    fetchInvitation: function(id) {
        console.log('fetchInvitation', id)
        const self = this
        self.loadViewObjectData(new Referee, {id: id}, function(data) {
            console.log('load invitation', data)
            self.target().member = data
        }, 'invite')
    }
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_RefereeInviteMediator, BaseMediator);

module.exports = tbs_controller_RefereeInviteMediator